import AdminMentorings from './container';

export default AdminMentorings;
